import 'regenerator-runtime/runtime';
import Vue from 'vue';
import { Matomo } from 'trackings';
import ScreenHome from './components/screen-home.vue';
import { Store } from './store.js';

new Matomo({
    trackerUrl : '//projects.haykranen.nl/stats/',
    siteId : 1
});

(async function() {
    const store = new Store();

    // Make sure the feed is never put in cache for more than 60 minutes
    const timestamp = new Date().toISOString().slice(0, 13);
    const feedUrl = `data/feed.json?cachebust=${timestamp}`;
    await store.load(feedUrl);

    new Vue({
        el : "main",

        components : { ScreenHome },

        methods : {
            go() {
                const hash = window.location.hash.slice(1);

                if (hash && !isNaN(parseInt(hash))) {
                    this.$store.commit('dateIndex', parseInt(hash));
                }
            }
        },

        mounted() {
            window.addEventListener('hashchange', () => {
                this.go();

                Vue.nextTick(() => {
                    window.scrollTo(0, 0);
                })
            });

            this.go();
        },

        render: h => h( ScreenHome ),

        store : store.getStore()
    });
})();